// extracted by mini-css-extract-plugin
export default {"type-writer-effect":"WelcomePage_type-writer-effect__t9QYw","typing":"WelcomePage_typing__YPKkz","blink":"WelcomePage_blink__53tkD"};